import { AxiosRequestConfig } from 'axios';
import api from '../../../../../api';

export interface ErrorResponseData {
  message: string;
  statusCode: number;
  details: {
    maxFileSize?: number;
  };
}

export async function handleUpload(file: File, config?: AxiosRequestConfig) {
  const formData = new FormData();
  formData.append('file', file);

  const { data } = await api.post('/studio/user/import', formData, {
    ...config,
    params: { ...config?.params, ianua: true },
  });
  return data.data;
}
